import request from '@/utils/request'

export function getDictList(data) {
  return request.post('/sys-dictionaries/list', data)
}



// WEBPACK FOOTER //
// ./src/api/dict.js